import React from 'react';
import cx from 'classnames';
import FaCircle from 'react-icons/lib/fa/circle';

import ClassProgressCell from './ClassProgressCell';
import getPRColor from './getPRColor';

import { COPY_STRINGS } from '../../../../constants/translatedCopy';
import { CLASSPROGRESS_COLORS } from "./constants";

function ClassProgressRow(props) {
  const {scores, rowNum, isBenchmarkOnly, benchmarkGrade, benchmarkName, selectedLocale} = props;
  const {
    BOY = {}, 
    MOY = {}, 
    EOY = {},
  } = scores;
  const { name } = Object.values(scores).filter((score) => score.name)[0];

  const recommendationOptions = {
    [CLASSPROGRESS_COLORS.RED]: COPY_STRINGS.recommendation_intervention, 
    [CLASSPROGRESS_COLORS.YELLOW]: COPY_STRINGS.recommendation_catch_up, 
    [CLASSPROGRESS_COLORS.GREEN]: COPY_STRINGS.recommendation_at_above, 
  };

  let latestCutoff = BOY && BOY.cutOff || null; // .cutOff will be "POOR", "AVERAGE", or "GOOD"
  if (MOY && MOY.cutOff) {
    latestCutoff = MOY.cutOff;
  }
  if (EOY && EOY.cutOff) {
    latestCutoff = EOY.cutOff;
  }

  // determine recommendation label
  let recommendationColor = latestCutoff ? {POOR: CLASSPROGRESS_COLORS.RED, AVERAGE: CLASSPROGRESS_COLORS.YELLOW, GOOD: CLASSPROGRESS_COLORS.GREEN}[latestCutoff] : null;
  const instructionalRecommendation = recommendationColor ? recommendationOptions[recommendationColor] : "None";
  const classProgressRecommendationStyles = cx({
    "classProgressRecommendation": true,
    [`classProgress${recommendationColor}Text`]: !!recommendationColor,
  });

  const hasPageBreak = rowNum !== 0 && rowNum % 22 === 0;
  const classProgressRowStyles = cx({
    "classProgressRow": true,
    "classProgressRowBreak": hasPageBreak,
  });

  return (
    <div className={classProgressRowStyles}>
      <div className="classProgressRowIndex">
        <div className="classProgressName">{name}</div>
        {!!recommendationColor && <div className={classProgressRecommendationStyles}>
          <div className="recommendationIcon"><FaCircle /></div>
          <div>{instructionalRecommendation}</div>
        </div>}
      </div>
      <div className="classProgressCellContainer">
        <ClassProgressCell season={BOY} isBenchmarkOnly={isBenchmarkOnly} benchmarkGrade={benchmarkGrade} benchmarkName={benchmarkName} studentName={BOY.name} selectedLocale={selectedLocale}/>
        <ClassProgressCell season={MOY} isBenchmarkOnly={isBenchmarkOnly} benchmarkGrade={benchmarkGrade} benchmarkName={benchmarkName} studentName={MOY.name} selectedLocale={selectedLocale}/>
        <ClassProgressCell season={EOY} isBenchmarkOnly={isBenchmarkOnly} benchmarkGrade={benchmarkGrade} benchmarkName={benchmarkName} studentName={EOY.name} selectedLocale={selectedLocale}/>
      </div>
    </div>
  );
}

export default React.memo(ClassProgressRow);